import "./DocumentExportApprovalPanel.css";

export default function DocumentExportApprovalPanel({
  approved,
  approvedBy,
  approvedAt,
  checked,
  onCheckedChange,
  onApprove,
  loading,
  disabled,
  checkboxText,
}) {
  return (
    <section className="document-export-approval" aria-label="Human review and export approval">
      <h3>Human review and export approval</h3>
      {approved ? (
        <p role="status">Approved for local export by {approvedBy} on {approvedAt}.</p>
      ) : (
        <p>This exact saved output is not approved for local export.</p>
      )}
      <label>
        <input
          type="checkbox"
          checked={checked}
          onChange={(event) => onCheckedChange(event.target.checked)}
        />
        {" "}{checkboxText}
      </label>
      <button
        type="button"
        className="button save"
        onClick={onApprove}
        disabled={disabled || loading || !checked || approved}
      >
        {loading ? "Saving approval..." : approved ? "Approved for local export" : "Approve for local export"}
      </button>
      <p>Approval authorizes only local copy/download. It does not file, submit, transmit, or represent independent counsel review.</p>
    </section>
  );
}
